import Header from "../../components/common/Header.js"
import Navbar from "../../components/common/Navbar.js"
import styled from "styled-components"
import Footer from "../../components/common/Footer.js"
import LeaderboardTable from "../../components/leaderboads/LeaderboardTable"

const Leaderboard = ({}) => {
  return (
    <>
      <Navbar />
      <Header title={"Leaderboard"} />
      <Wrapper>
        <LeaderboardTable />
      </Wrapper>
      <Footer />
    </>
  )
}

export default Leaderboard

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 0.5rem;
  @media (min-width: 567px) {
    padding: 0 2rem;
  }
  @media (min-width: 567px) {
    padding: 0 4rem;
  }
`
